import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail, Loader2 } from "lucide-react";
import { adminLogin, getAdminToken } from "@/lib/adminApi";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getAdminToken()) nav("/admin", { replace: true });
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await adminLogin(email, password);
      toast.success("Signed in");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  const inputWrap = "mt-2 flex items-center rounded-xl border border-slate-200 bg-slate-50 focus-within:border-lime-500 focus-within:bg-white transition";
  const input = "w-full bg-transparent px-3 py-3 text-sm text-slate-900 outline-none";
  const label = "block text-xs font-semibold uppercase tracking-wider text-slate-500";

  return (
    <div className="min-h-screen w-full bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 text-center">
          <div className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-lime-600">
            <span className="h-2 w-2 rounded-full bg-lime-500" /> Event OS
          </div>
          <h1 className="mt-2 font-display text-3xl font-bold text-slate-900">Bharat Ethanol Forum</h1>
          <p className="mt-1 text-sm text-slate-500">Admin control panel</p>
        </div>
        <form onSubmit={submit} className="rounded-2xl border border-slate-200 bg-white p-7 shadow-xl shadow-slate-200/60">
          <label className={label}>Email</label>
          <div className={inputWrap}>
            <Mail className="ml-3 h-4 w-4 text-slate-400" />
            <input
              data-testid="admin-email-input"
              type="email"
              autoFocus
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className={input}
            />
          </div>

          <label className={`${label} mt-5`}>Password</label>
          <div className={inputWrap}>
            <Lock className="ml-3 h-4 w-4 text-slate-400" />
            <input
              data-testid="admin-password-input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              className={input}
            />
          </div>

          <button
            data-testid="admin-login-submit"
            disabled={loading || !email || !password}
            className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
            Sign in
          </button>
          <p className="mt-4 text-center text-xs text-slate-400">Restricted access. Attempts are logged.</p>
        </form>
      </div>
    </div>
  );
}
